export enum CreditCardType {
  AMEX = 'AMEX',
  A = 'A',
  MASTERCARD = 'MASTERCARD',
  MASTER = 'MASTER',
  M = 'M',
  VISA = 'VISA',
  V = 'V',
  UNKNOWN = 'NA',
}

export interface CardType {
  name: string;
  imagePath: string;
}

export class CardTypeConstant {
  static VISA: CardType = {
    name: 'VISA',
    imagePath: 'assets/images/payment/visa.svg',
  };
  static MASTERCARD: CardType = {
    name: 'MASTERCARD',
    imagePath: 'assets/images/payment/mastercard.svg',
  };
  static MASTER: CardType = {
    name: 'MASTERCARD',
    imagePath: 'assets/images/payment/mastercard.svg',
  };
  static AMEX: CardType = {
    name: 'AMEX',
    imagePath: 'assets/images/payment/amex.svg',
  };
}

export enum SemafoneResponseStatus {
  Active = 'ACTIVE',
  Fail = 'FAIL',
  Ok = 'OK',
  Success = 'SUCCESS',
  Error = 'ERROR',
  Unknown = 'UNKNOWN',
}

export interface SemafoneRequestParams {
  semafoneLicCode: string;
  semafonePassword: string;
  semafoneHost: string;
  accountId: string;
  userId: string;
  principle: string;
  isPanResetOnInitialFocus?: boolean;
}

export interface CreditCardNumberInputFormData {
  creditCardInputLabel: string;
  creditCardAltText: string;
  creditCardErrorMessage: string;
}

export interface CreditCardNumberOutput {
  token?: string;
  creditCardType?: CreditCardType;
  securityCodeLimit?: number;
}
